<template>
  <div class="module-id">
    <label class="module-id__label mb-2">
      <h3>
        {{ label }}
      </h3>
    </label>
    <div class="module-id__info">
      <input
        ref="copy-field"
        class="module-id__info__data"
        readonly
        :value="value"
      />
      <button
        class="module-id__info__copy text-white"
        @click="copyData()"
      >
        <IconCopy size="xs" />
      </button>
    </div>
  </div>
</template>

<script>
import IconCopy from '@/components/icons/IconCopy.vue';
import commonProperties from './common-properties';

export default {
  name: 'ModuleId',
  components: {
    IconCopy,
  },
  mixins: [commonProperties],
  inheritAttrs: false,
  methods: {
    copyData() {
      let copyText = this.$refs['copy-field'];

      if (copyText.length > 0) {
        [copyText] = copyText;
      }

      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand('copy');
    },
  },
};
</script>

<style lang="scss" scoped>
.module-id {
  padding: 15px 20px;

  &__label h3 {
    color: $gray-700;
    font-weight: $lb-medium;
    font-size: $size-normal;
    line-height: 1.5;
  }

  &__info {
    background: fade-out($crm-blue-primary, 0.85);
    border-radius: 4px;
    padding: 12px;
    position: relative;
    display: flex;
    justify-content: space-between;

    &__data {
      background: none;
      color: #d55d7c;
      border: 0;
      outline: 0;
      flex-grow: 1;

      &::selection {
        background-color: #d55d7c;
        color: $lb-white;
      }
    }

    &__copy {
      background: $crm-blue-primary;
      padding: 8px;
      border-radius: 100px;
      border: 0;
      outline: 0;
      flex-shrink: 0;
      margin-left: 12px;

      .icon {
        display: block;
      }
    }
  }
}
</style>
